(function ($) {
  Drupal.behaviors.tiled_video_grid_formatter_mob_v1 = {
    attach: function (context) {
      $('.js-tvgf_formatter_v1', context).once(function (idx, element) {
        const $thismodule = $(element);
        const triggerMod = '#anr_repromote_mod4';
        const thisModuleName = 'how_many_ways_vids';
        const controller = new ScrollMagic.Controller();
        const moduleWillFade = $thismodule.data('scrollmagic') === 1;
        const clonedSlideVal = 4;
        const directionIncrement = 100;
        const pagIncrement = 29.2;
        const $heroImage = $thismodule.find('.js-tvgf_formatter_v1__hero');
        const $heroVideoSrc = $thismodule.find('.js-ytPlayer__icon');
        const $moduleContainer = $thismodule.find('.js-tvgf_formatter_v1__container');
        const $eachTile = $thismodule.find('.js-tvgf_tile_v1');
        const $firstTile = $eachTile.eq(0);
        const $lastTile = $eachTile.eq(-1);
        const $tileGrid = $thismodule.find('.js-tvgf_formatter_v1__grid');
        let $firstSlidePag,
          $secondSlidePag,
          $thirdSlidePag,
          $fourthSlidePag,
          $fourthLastSlidePag,
          $thirdLastSlidePag,
          $secondLastSlidePag,
          $lastSlidePag;
        let $firstSlideHero,
          $secondSlideHero,
          $thirdSlideHero,
          $fourthSlideHero,
          $fourthLastSlideHero,
          $thirdLastSlideHero,
          $secondLastSlideHero,
          $lastSlideHero;
        const $heroCarousel = $thismodule.find('.js-tvgf_formatter_v1__heroCarousel');
        let $heroSlides, $tileSelected;
        const $chevronLeft = $thismodule.find('.js-el_boutique_carouselnav_1');
        const $chevronRight = $thismodule.find('.js-el_boutique_carouselnav_2');
        const firstTileHero = $firstTile.find('.el_boutique_img_full').data('hero-src');
        const firstTileVideo = $firstTile.data('yt-src');
        const urlHash = window.location.href.split('#')[1];
        let hasFaded = false;
        let offset, fadeThisModuleScene;
        const lazyloadSrc = 'data-src';
        const tileVidSrc = 'data-yt-src';
        const heroVidSrc = 'data-yt-dynamic-src';
        let thisTilesHeroSrc, thisVidAttr;
        const slideTotal = $eachTile.length;
        const dynamicTiles = '.js-tvgf_tile_v1';
        const dynamicTileClass = '.js-tile-';
        const tileSelectedClass = 'tile__selected';
        const tileIsSelected = '.tile__selected';
        const pagClasses =
          'tile__selected js-next_pag js-next_pag_far js-previous_pag js-previous_pag_far';
        let pagNumGrab,
          pagNum,
          resetVal,
          roundedVal,
          whichValPrev,
          whichValPrevFar,
          whichValNxt,
          whichValNxtFar,
          carouselIncrementPag,
          pagCarouselDirection,
          pagTileSelected;
        let pagAnimating = false;
        const slideDivide = slideTotal / slideTotal;
        const pagCount = slideTotal;

        // If module is called in URL, scroll to module.
        if (urlHash === thisModuleName) {
          $('html,body').animate(
            {
              scrollTop: $thismodule.offset().top - 85
            },
            1500
          );
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        // Set the first tile to be active
        $firstTile.addClass(tileSelectedClass);

        // Set the hero image of the grid on page load.
        $heroImage.attr(lazyloadSrc, firstTileHero).addClass('lazyload');

        // Set the hero video of the grid on page load.
        $heroVideoSrc.attr(heroVidSrc, firstTileVideo);

        // Create Hero Image
        $eachTile.each(function () {
          thisTilesHeroSrc = $(this).find('.el_boutique_img_full').data('hero-src');
          $('.tvgf_formatter_v1__heroCarousel').append(
            '<div class="el_boutique_img_wrapper js-tvgf_slide_v1"><img class="el_boutique_img_full tvgf_formatter_v1__hero js-tvgf_formatter_v1__hero lazyload" data-src="' +
              thisTilesHeroSrc +
              '"></div>'
          );
        });

        // Handle Tile pagination events.
        // Add classes.
        $eachTile.each(function (i) {
          $(this).addClass('js-tile-' + (i + 1));
        });
        $firstTile.next().addClass('js-next_pag').next().addClass('js-next_pag_far');
        $lastTile.addClass('js-previous_pag').prev().addClass('js-previous_pag_far');

        // Create hero image clones for infinite scrolling.
        $heroSlides = $thismodule.find('.js-tvgf_slide_v1');
        ($firstSlideHero = $heroSlides.eq(0).clone()),
          ($secondSlideHero = $heroSlides.eq(1).clone()),
          ($thirdSlideHero = $heroSlides.eq(2).clone()),
          ($fourthSlideHero = $heroSlides.eq(3).clone()),
          ($fourthLastSlideHero = $heroSlides.eq(-4).clone()),
          ($thirdLastSlideHero = $heroSlides.eq(-3).clone()),
          ($secondLastSlideHero = $heroSlides.eq(-2).clone()),
          ($lastSlideHero = $heroSlides.eq(-1).clone());
        $fourthLastSlideHero
          .add($thirdLastSlideHero)
          .add($secondLastSlideHero)
          .add($lastSlideHero)
          .insertBefore($heroSlides.eq(0));
        $firstSlideHero
          .add($secondSlideHero)
          .add($thirdSlideHero)
          .add($fourthSlideHero)
          .insertAfter($heroSlides.eq(-1));

        // Create pagination clones for infinite scrolling.
        ($firstSlidePag = $firstTile.clone()),
          ($secondSlidePag = $eachTile.eq(1).clone()),
          ($thirdSlidePag = $eachTile.eq(2).clone()),
          ($fourthSlidePag = $eachTile.eq(3).clone()),
          ($fourthLastSlidePag = $eachTile.eq(-4).clone()),
          ($thirdLastSlidePag = $eachTile.eq(-3).clone()),
          ($secondLastSlidePag = $eachTile.eq(-2).clone()),
          ($lastSlidePag = $lastTile.clone());
        $fourthLastSlidePag
          .add($thirdLastSlidePag)
          .add($secondLastSlidePag)
          .add($lastSlidePag)
          .insertBefore($firstTile);
        $firstSlidePag
          .add($secondSlidePag)
          .add($thirdSlidePag)
          .add($fourthSlidePag)
          .insertAfter($lastTile);
        $fourthLastSlidePag
          .add($thirdLastSlidePag)
          .add($secondLastSlidePag)
          .add($lastSlidePag)
          .add($firstSlidePag)
          .add($secondSlidePag)
          .add($thirdSlidePag)
          .add($fourthSlidePag)
          .addClass('js-cloned_sec');
        $firstSlidePag.removeClass(tileSelectedClass);

        // Ensuring one class has tile__selected
        function tileSelected(whichSlide) {
          $(dynamicTiles).removeClass(tileSelectedClass);
          $(dynamicTileClass + whichSlide)
            .not('.js-cloned_sec')
            .addClass(tileSelectedClass);
        }

        // Reset the pagination position for infinite scrolling.
        function resetPagCarousel($this, pagNum) {
          if ($this.hasClass('js-cloned_sec')) {
            if (pagNum === slideDivide) {
              resetVal = '0';
              $tileGrid.css({
                left: resetVal
              });
              $heroCarousel.css({
                left: '-' + clonedSlideVal * 100 + '%'
              });
              tileSelected(slideDivide);
            } else if (pagNum === slideDivide + 1) {
              resetVal = pagIncrement;
              $tileGrid.css({
                left: '-' + resetVal + '%'
              });
              $heroCarousel.css({
                left: '-' + (clonedSlideVal + 1) * 100 + '%'
              });
              pagTileSelected = slideDivide + 1;
              tileSelected(pagTileSelected);
            } else if (pagNum === pagCount) {
              resetVal = pagIncrement * (pagCount - 1);
              roundedVal = Math.round(resetVal * 10) / 10;
              $tileGrid.css({
                left: '-' + roundedVal + '%'
              });
              $heroCarousel.css({
                left: '-' + (pagCount + clonedSlideVal - 1) * 100 + '%'
              });
              tileSelected(pagCount);
            } else if (pagNum === pagCount - 1) {
              resetVal = pagIncrement * (pagCount - 2);
              roundedVal = Math.round(resetVal * 10) / 10;
              $tileGrid.css({
                left: '-' + roundedVal + '%'
              });
              $heroCarousel.css({
                left: '-' + (pagCount + clonedSlideVal - 2) * 100 + '%'
              });
              pagTileSelected = pagCount - 1;
              tileSelected(pagTileSelected);
            }
          }
          pagAnimating = false;
        }

        // Animate pag wrapper carousel
        function animatePagCarousel($this, pagNum, pagCarouselDirection, carouselIncrementPag) {
          $heroCarousel.animate(
            {
              left: carouselIncrementPag
            },
            600,
            'easeInOutQuad'
          );
          $tileGrid.animate(
            {
              left: pagCarouselDirection
            },
            600,
            'easeInOutQuad',
            function () {
              resetPagCarousel($this, pagNum);
            }
          );
        }

        // Account for jumps to cloned slides and resetting pag position.
        function resetPagClasses(whichValPrev, whichValPrevFar, whichValNxt, whichValNxtFar) {
          $(dynamicTileClass + whichValPrev).addClass('js-previous_pag');
          $(dynamicTileClass + whichValPrevFar).addClass('js-previous_pag_far');
          $(dynamicTileClass + whichValNxt).addClass('js-next_pag');
          $(dynamicTileClass + whichValNxtFar).addClass('js-next_pag_far');
        }

        // Checks for certain slides to account for cloned slides and resetting pag position.
        function checkPagCount($this, pagNum, pagCarouselDirection, carouselIncrementPag) {
          if (pagNum === slideDivide) {
            whichValPrevFar = pagCount - 1;
            whichValNxt = slideDivide + 1;
            whichValNxtFar = slideDivide + 2;
            resetPagClasses(pagCount, whichValPrevFar, whichValNxt, whichValNxtFar);
          } else if (pagNum === slideDivide + 1) {
            whichValNxt = slideDivide + 2;
            whichValNxtFar = slideDivide + 3;
            resetPagClasses(slideDivide, pagCount, whichValNxt, whichValNxtFar);
          } else if (pagNum === pagCount) {
            whichValPrev = pagCount - 1;
            whichValPrevFar = pagCount - 2;
            whichValNxtFar = slideDivide + 1;
            resetPagClasses(whichValPrev, whichValPrevFar, slideDivide, whichValNxtFar);
          } else if (pagNum === pagCount - 1) {
            whichValPrev = pagCount - 2;
            whichValPrevFar = pagCount - 3;
            resetPagClasses(whichValPrev, whichValPrevFar, pagCount, slideDivide);
          }
          animatePagCarousel($this, pagNum, pagCarouselDirection, carouselIncrementPag);
        }

        // Only carry on if the pagination isn't already animating.
        function isPagAnimating($this, pagNum, pagCarouselDirection, carouselIncrementPag) {
          if (pagAnimating === false) {
            pagAnimating = true;
            $this.removeClass(pagClasses).siblings().removeClass(pagClasses);
            $this.addClass(tileSelectedClass);
            $this.next().addClass('js-next_pag');
            $this.prev().addClass('js-previous_pag');
            $this.next('.js-next_pag').next().addClass('js-next_pag_far');
            $this.prev('.js-previous_pag').prev().addClass('js-previous_pag_far');
            checkPagCount($this, pagNum, pagCarouselDirection, carouselIncrementPag);
          }
        }

        // Determine direction of carousel according to visible slides.
        function classTest($this, pagNum) {
          if ($this.hasClass('js-next_pag')) {
            pagCarouselDirection = '-=' + pagIncrement + '%';
            carouselIncrementPag = '-=' + directionIncrement + '%';
          } else if ($this.hasClass('js-next_pag_far')) {
            pagCarouselDirection = '-=' + pagIncrement * 2 + '%';
            carouselIncrementPag = '-=' + directionIncrement * 2 + '%';
          } else if ($this.hasClass('js-previous_pag')) {
            pagCarouselDirection = '+=' + pagIncrement + '%';
            carouselIncrementPag = '+=' + directionIncrement + '%';
          } else if ($this.hasClass('js-previous_pag_far')) {
            pagCarouselDirection = '+=' + pagIncrement * 2 + '%';
            carouselIncrementPag = '+=' + directionIncrement * 2 + '%';
          }
          isPagAnimating($this, pagNum, pagCarouselDirection, carouselIncrementPag);
        }

        // If the pag selected is not already active.
        function animatePagRow($this, pagNum) {
          if (!$this.hasClass(tileSelectedClass)) {
            classTest($this, pagNum);
          }
        }

        // Handle tile events.
        $tileGrid.on('click', dynamicTiles, function () {
          const $this = $(this);

          pagNumGrab = $this.attr('class').match(/js-tile-(\d+)/)[1];
          pagNum = parseInt(pagNumGrab);
          thisVidAttr = $this.attr(tileVidSrc);
          $heroVideoSrc.attr(heroVidSrc, thisVidAttr);
          animatePagRow($this, pagNum);
        });

        // Handle chevron events.
        $chevronLeft.on('click', function () {
          $tileSelected = $thismodule.find(tileIsSelected);
          $tileSelected.prev().trigger('click');
        });
        $chevronRight.on('click', function () {
          $tileSelected = $thismodule.find(tileIsSelected);
          $tileSelected.next().trigger('click');
        });

        // Mobile swiping.
        $moduleContainer.swiperight(function () {
          $chevronLeft.trigger('click');
        });
        $moduleContainer.swipeleft(function () {
          $chevronRight.trigger('click');
        });

        $(window).on('load', function () {
          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.
            if ($thismodule.data('offset')) {
              offset = $thismodule.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });
            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
